import { DataListModel } from './../../shared/config';
import { TranslateService } from './../../shared/translate/translate.service';
import { AuthService } from './../../shared/models/auth.service';
import { InboxModel } from './../models/inbox.model';
import { Router, ActivatedRoute } from '@angular/router';
import { InboxService } from './../models/inbox.service';
import { Component, OnInit, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'wego-driver-inbox-list',
  template: require('../views/inbox-driver.component.html'),
  styles: [`
          .box.box-default{
            border: 1px solid #ddd;
            border-top: 3px solid #2BA2AA;
          }
          .box-body{
            padding: 0px 10px 10px;
          }
          .maintext { 
            display:block;
          }
          .subtext {
            font-size: smaller; 
          }
          .unread{
            font-weight: bold;
          }
          .fa-sm{
            font-size: 0.7em;
            line-height: 0.7em;
            vertical-align: 20%;
          }
          `
  ],
  providers: [InboxService]
})
export class InboxDriverListComponent implements OnInit {
  private DataListModel: DataListModel;
  private isLoading: boolean;
  private apiErrorMsg: string;
  private inboxList: InboxModel[];
  private sub: any;
  private notificationInboxHashID: string;

  constructor(
    private authService: AuthService
    , private router: Router
    , private activeRoute: ActivatedRoute
    , private translate: TranslateService
    , private inboxService: InboxService) {
  }

  ngOnInit() {
    this.DataListModel = this.authService.RetriveFilter(this.constructor.name);
    this.DataListModel.searchField = ["subject", "from"];
    this.HandleRefresh();
  }

  private HandleRefresh() {
    this.sub = this.activeRoute
      .params
      .subscribe(params => {
        this.GetNotificationInboxList();
      });
  }

  private OnSort(sortName: string) {
    this.DataListModel.sortType = sortName;
    this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
    this.GetNotificationInboxList();
  }

  private OnSearch(event: any) {
    this.DataListModel = this.authService.GetSearchParameters(this.DataListModel, event.searchTerm, event.isReset);
    this.GetNotificationInboxList();
  }

  private OnPageChanged(event: any): void {
    this.DataListModel.currentPage = event.page;
    this.GetNotificationInboxList();
  }

  public OnPagingChange(event: any) {
    this.DataListModel.currentPage = 1;
    this.DataListModel.totalItems = 0;
    this.DataListModel.itemsPerPage = event.itemPerPage;
    this.GetNotificationInboxList();
  }

  private ShowNotification(notificationInboxHashID: string) {
    if (this.inboxList && this.inboxList.length > 0) {
      this.inboxList.forEach(x => x.isSelected = false);
      let record = this.inboxList.find(x => x.notificationInboxHashID == notificationInboxHashID);
      record.isRead = true;
      record.isSelected = true;
    }
    this.notificationInboxHashID = notificationInboxHashID;
  }

  private GetNotificationInboxList() {
    this.isLoading = true;
    this.inboxService.GetNotificationInboxList(this.DataListModel)
      .subscribe(
      res => {
        this.inboxList = res.data;
        this.DataListModel.totalItems = res.totalRecords;
        this.DataListModel.infoMessage = res.error;
        this.isLoading = false;
      },
      error => {
        this.HandleErrorStatusCode(error);
        this.isLoading = false;
      });
  }

  private HandleErrorStatusCode(error: any) {
    if (error && error == "401") {
      this.router.navigate(['/Unauthorized']);
    }
    else if (error && error == "403") {
      this.router.navigate(['/Unauthenticated']);
    }
    else {
      this.apiErrorMsg = error;
    }
  }
  ngOnDestroy() {
    this.authService.SetFilter(this.constructor.name, this.DataListModel);
  }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/inbox/components/inbox-driver.component.ts